import client from 'data/client';
import { QualityData } from 'data/types/quality';
import { normalizeQuality } from 'model/quality';

const getQuality = async (brandId: string) => {
  const response = await client.get<QualityData>(
    `/reporting/quality?brandId=${brandId}`,
  );

  return normalizeQuality(response.data);
};

export default getQuality;
